import React from 'react';
import { useNetwork } from '../../hooks/useNetwork';
import './NetworkBanner.css';

const NetworkBanner = () => {
  const { isOnline, isChecking, checkServerHealth } = useNetwork();

  if (isOnline) return null;

  return (
    <div className="network-banner" role="status" aria-live="polite">
      <span className="network-banner__message">
        ⚠️ Pas de connexion internet ou serveur inaccessible
      </span>
      <button
        type="button"
        className="network-banner__refresh"
        onClick={() => checkServerHealth()}
        disabled={isChecking}
        aria-label="Réessayer la connexion"
      >
        {isChecking
          ? <span className="network-banner__spinner" aria-hidden="true" />
          : <span aria-hidden="true">↻</span>}
        {isChecking ? 'Vérification…' : 'Réessayer'}
      </button>
    </div>
  );
};

export default NetworkBanner;
